import {
  labeled,
  stringRequired,
  stringOptional,
  numberRequired,
  numberOptional
} from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object()
    .keys({
      suiteNumber: Joi.alternatives().conditional('isPostOfficeBoxEnabled', {
        is: true,
        then: stringOptional(Joi, 1, 16).label(labeled(label, 'Address - Suite number')),
        otherwise: stringOptional(Joi, 1, 16).label(labeled(label, 'Address - Suite number'))
      }),
      streetNumber: Joi.alternatives().conditional('isPostOfficeBoxEnabled', {
        is: true,
        then: Joi.alternatives(
          stringOptional(Joi, 1, 16).label(labeled(label, 'Address - Street number')),
          numberOptional(Joi, 1).label(labeled(label, 'Address - Street number'))
        ),
        otherwise: Joi.alternatives(
          stringRequired(Joi, 1, 16).label(labeled(label, 'Address - Street number')),
          numberRequired(Joi, 1).label(labeled(label, 'Address - Street number'))
        )
      }),
      street: Joi.alternatives().conditional('isPostOfficeBoxEnabled', {
        is: true,
        then: stringOptional(Joi, 1, 128).label(labeled(label, 'Address - Street name')),
        otherwise: stringRequired(Joi, 1, 128).label(labeled(label, 'Address - Street name'))
      }),
      streetType: Joi.alternatives().conditional('isPostOfficeBoxEnabled', {
        is: true,
        then: stringOptional(Joi, 1, 32).label(labeled(label, 'Address - Street type')),
        otherwise: stringRequired(Joi, 1, 32).label(labeled(label, 'Address - Street type'))
      }),
      postOfficeBox: Joi.alternatives().conditional('isPostOfficeBoxEnabled', {
        is: true,
        then: stringRequired(Joi, 1, 32).label(labeled(label, 'Address - PO box number')),
        otherwise: stringOptional(Joi, 1, 32).label(labeled(label, 'Address - PO box number'))
      }),
      suburb: stringRequired(Joi, 1, 64).label(labeled(label, 'Address - Suburb')),
      city: stringOptional(Joi, 1, 64).label(labeled(label, 'Address - City')),
      state: stringOptional(Joi, 1, 64).label(labeled(label, 'Address - State')),
      // countryCode: stringRequired(Joi, 1, 8).label(labeled(label, 'Address - Country code')),
      country: stringRequired(Joi, 1, 64).label(labeled(label, 'Address - Country')),
      // latitude: numberOptional(Joi).label(labeled(label, 'Address - Latitude')),
      // longitude: numberOptional(Joi).label(labeled(label, 'Address - Longitude')),
      postCode: stringRequired(Joi, 1, 16).label(labeled(label, 'Address - Postcode'))
      // district: stringRequired(Joi, 1, 64).label(labeled(label, 'Address - District'))
      // formatted: stringRequired(Joi, 1, 256).label(labeled(label, 'Address - Formatted'))
    })
    .when('.country', {
      is: Joi.string().valid('Australia').required(),
      then: Joi.object().keys({
        state: stringRequired(Joi, 1, 64).label(labeled(label, 'Address - State'))
      }),
      otherwise: Joi.object().keys({
        city: stringRequired(Joi, 1, 64).label(labeled(label, 'Address - City'))
      })
    });

export default {
  schema
};
